<template>
  <div class="body-container order-detail main">
    <div class="top-box">
      <div class="text1">{{detail.productName}}</div>
      <div class="text3"><span class="title">保单号：</span><span class="num">{{detail.policyNo}}</span></div>
      <div class="text2" v-if="detail.companyName">由{{detail.companyName}}承保</div>
      <div class="float-img">
        <img class="status-img" v-if="detail.policyStatus==1" src="@static/images/order/bzz.png">
        <img class="status-img" v-else-if="detail.policyStatus==5" src="@static/images/order/ysx.png">
      </div>
    </div>
    <div class="box">
      <div class="box-title">保单信息</div>
      <div class="text" >
        <span class="label">投保人姓名</span>
        <span>{{detail.holderName}}</span>
      </div>
      <div class="text" >
        <span class="label">被保人姓名</span>
        <span>{{detail.insuranceName}}</span>
      </div>
      <div class="text" >
        <span class="label">被保人身份证号</span>
        <span>{{detail.insuranceIdCardFuzz}}</span>
      </div>
      <div class="text">
        <span class="label">与投保人关系</span>
        <span>{{detail.familyMember}}</span>
      </div>
      <div class="text">
        <span class="label">保费（元）</span>
        <span>{{detail.fee|filterFee}}</span>
      </div>
      <div class="text">
        <span class="label">保额（元）</span>
        <span>{{detail.totalInsured|filterFee}}</span>
      </div>
      <div class="text" >
        <span class="label">保险生效日</span>
        <span>{{detail.startTime|timeSplit}}</span>
      </div>
      <div class="text" >
        <span class="label">保险期限</span>
        <span v-if="detail.guarateeType==1">{{detail.startTime|timeSplit}}至终身</span>
        <span v-else>{{detail.startTime|timeSplit}}至{{detail.endTime|timeSplit}}</span>
      </div>
      <div class="text">
        <span class="label">录入时间</span>
        <span>{{detail.createTime|timeStatus}}</span>
      </div>

    </div>
  </div>
</template>
<script>
import {common} from "@/api/mixins";
import addPolicy from "./components/addPolicy";
export default {
  mixins:[common],
  components:{addPolicy},
  data() {
    return {
      id:"",
      detail: {},
      plat:'bplat',//A端B端
      policyNo:'',
    };
  },
  computed:{
  },
  created() {
    if(!this.checkLogin('/m/personal/index')){
      return;
    }
    this.id = this.$route.query.id;
    this.detailHttp();
  },
  methods: {
    detailHttp: function() {
      this.loading = true;
      this.$http({
        type: "PUT",
        url: `/api/queryEnteryPolicyDetail/${this.plat}/${this.id}`,

      }).then(resData => {
        this.loading = false;
        this.detail = resData.data;
        this.$weixin.hideMenu();
      }).catch(e=>{
        this.loading = false;
      });
    },
  },
  filters:{
    filterFee(val){
      if(!val){
        return '0.00'
      }else{
        return (val*1).toFixed(2)
      }
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./detail";
</style>
<style lang='scss'>
.downLoadDialog{
  border-radius: 10px;
  .van-dialog__header{
    font-size: 34px;
    font-weight: 500;
    line-height: 48px;
    color: #333333;
  }
  .van-dialog__content{
    word-break: break-all;
    padding:40px;
    >div{
      display: flex;
      align-items: flex-start;
      .desc{
        font-size: 28px;
        font-weight: 400;
        line-height: 40px;
        color: #666666;
        margin-left: 20px;
      }
    }
  }
  .van-dialog__message{
    font-size: 28px;
    color: #666666;
  }
  .van-dialog__footer{
    background: #E7E7E7;
    .van-button{
      background: #F5F7FA;
    }
    .van-dialog__cancel,.van-dialog__confirm{
      font-size: 28px;
      font-weight: 400;
      line-height: 40px;

    }
    .van-dialog__cancel{
      color: #8A9095;
      border-right: 1px solid #E7E7E7;
    }
    .van-dialog__confirm{
      color: #333333;
    }
  }
}
</style>
